module.exports = __webpack_public_path__ + "static/media/tesla.f08cdd40.svg";